export const ALL_SOURCES_MONITORING_ID = 'lahteet';
export const ALERTS_MONITORING_ID = 'alertit';

// @TEMPLATE: Define the routes here.
const RoutePaths = {
    root: {
        root: '/arkistokanta',
        search: '/arkistokanta/search',
    },
    newsQueue: {
        root: '/',
        article: 'article/:articleId',
        mediaSelection: '/mediavalinta',
        shorthand: '/pikavalinta/:name',
        desk: '/desk/:id',
        media: '/media/:id',
    },
    monitoring: {
        root: '/monitorointi',
        allSources: `/monitorointi/${ALL_SOURCES_MONITORING_ID}`,
        alerts: `/monitorointi/${ALERTS_MONITORING_ID}`,
        media: '/monitorointi/:mediaId',
        source: '/monitorointi/:mediaId/:sourceId',
        run: '/monitorointi/:mediaId/:sourceId/:runId',
    },
}

export default RoutePaths;
